import { Button, Text, VStack } from "@chakra-ui/react";
import { KYDAdminEventSummary } from "@common/interfaces/KYDEvent";
import BundleEvent from "./BundleEvent";
import { formatEventDateWithYear } from "src/utils";

const BundleEventsTable = ({
  loading,
  eventsInBundle,
  setEventsInBundle,
  isEditingEvents,
  setIsEditingEvents,
  isMutatingBundleItems,
  setIsMutatingBundleItems,
  onUpdateBundle,
}: {
  loading: boolean;
  eventsInBundle: KYDAdminEventSummary[];
  setEventsInBundle: React.Dispatch<
    React.SetStateAction<KYDAdminEventSummary[]>
  >;
  isEditingEvents: boolean;
  setIsEditingEvents: React.Dispatch<React.SetStateAction<boolean>>;
  isMutatingBundleItems: boolean;
  setIsMutatingBundleItems: React.Dispatch<React.SetStateAction<boolean>>;
  onUpdateBundle: ({ events }: { events: string[] }) => Promise<void>;
}) => {
  const onDelete = async (id: KYDAdminEventSummary["id"]) => {
    if (isMutatingBundleItems) {
      return;
    }
    const events = eventsInBundle.filter((e) => e.id !== id);
    setEventsInBundle(events);
    setIsMutatingBundleItems(true);
    try {
      await onUpdateBundle({ events: events.map((e) => e.id) });
    } finally {
      setIsMutatingBundleItems(false);
    }
  };

  return (
    <>
      {eventsInBundle.length ? (
        <VStack align="stretch" spacing={0}>
          {eventsInBundle.map((eventInBundle) => {
            return (
              <BundleEvent
                key={eventInBundle.id}
                isDisabled={loading || isMutatingBundleItems}
                onDelete={onDelete}
                isEditingEvents={isEditingEvents}
                id={eventInBundle.id}
                image={eventInBundle.image}
                link={"link" in eventInBundle ? eventInBundle.link : ""}
                name={eventInBundle.name}
                startAt={formatEventDateWithYear(
                  eventInBundle.start_at,
                  eventInBundle.timezone
                )}
                venueName={eventInBundle.venue?.name}
              />
            );
          })}
        </VStack>
      ) : null}
      {eventsInBundle.length === 0 ? (
        <VStack py={4}>
          <Text color="gray.500">No events added in this bundle yet</Text>
        </VStack>
      ) : null}
    </>
  );
};

export default BundleEventsTable;
